import React from "react";
import css from "./BasicInfo.module.css";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import clsx from "clsx";

import icon01 from "../../images/icon-01.png";
import icon02 from "../../images/icon-02.png";
import icon03 from "../../images/icon-03.png";
import icon04 from "../../images/icon-04.png";
import icon05 from "../../images/icon-05.png";
import icon06 from "../../images/icon-06.png";
import icon07 from "../../images/icon-07.png";


const BasicInfo = () => {

    return (
        <Box className={css.basicInfo}>

                <Box className={css.responsiveGrid}>
                    <Box className={clsx(css.apla, 'apla')}>
                        <Box className={css.icon}>
                            <img src={icon01} alt={css.icon}/>
                        </Box>
                        <Box className={css.content}>
                            <Typography variant='h5' className={css.title}>
                                Dlaczego warto wybrać lokalnego dostawcę internetu, telewizji i telefonu?
                            </Typography>
                            <Typography variant='p' className={css.info}>
                                Lokalni.pl to wyszukiwarka, dzięki której znajdziesz w swojej okolicy
                                najlepszego dostawcę internetu, telewizji i telefonu.
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={clsx(css.apla, 'apla')}>
                        <Box className={css.icon}>
                            <img src={icon02} alt={css.icon}/>
                        </Box>
                        <Box className={css.content}>
                            <Typography variant='h5' className={css.title}>
                                Jakość usług
                            </Typography>
                            <Typography variant='p' className={css.info}>
                                Lokalny operator działa na Twoim obszarze geograficznym, dzięki temu jakość
                                sieci, a co za tym idzie - usług jest znacznie wyższa niż u ogólnopolskich
                                dostawców.
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={clsx(css.apla, 'apla')}>
                        <Box className={css.icon}>
                            <img src={icon03} alt={css.icon}/>
                        </Box>
                        <Box className={css.content}>
                            <Typography variant='h5' className={css.title}>
                                Stabilne i szybkie łącze
                            </Typography>
                            <Typography variant='p' className={css.info}>
                                Lokalny operator działa na wybudowanej przez siebie infrastrukturze, która
                                jest dostosowana do specyfiki regionu. Dzięki temu połączenie z internetem
                                jest bardziej stabilne i szybkie.
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={clsx(css.apla, 'apla')}>
                        <Box className={css.icon}>
                            <img src={icon04} alt={css.icon}/>
                        </Box>
                        <Box className={css.content}>
                            <Typography variant='h5' className={css.title}>
                                Dostępność
                            </Typography>
                            <Typography variant='p' className={css.info}>
                                Lokalny operator jest blisko, dzięki temu szybko reaguje na ewentualne
                                problemy techniczne. Gdy dzwonisz, wsparcia udzieli Ci doświadczony konsultant.
                                Nie trzeba próbować dogadać się z botem lub wisieć godzinami w oczekiwaniu
                                na połączenie z infolinią.
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={clsx(css.apla, 'apla')}>
                        <Box className={css.icon}>
                            <img src={icon05} alt={css.icon}/>
                        </Box>
                        <Box className={css.content}>
                            <Typography variant='h5' className={css.title}>
                                Indywidualne podejście
                            </Typography>
                            <Typography variant='p' className={css.info}>
                                Lokalnym firmom zależy. Nie jesteś tylko "cyferką w excelu",
                                dlatego u Lokalnych normalne jest elastyczne podejście do klienta.
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={clsx(css.apla, 'apla')}>
                        <Box className={css.icon}>
                            <img src={icon06} alt={css.icon}/>
                        </Box>
                        <Box className={css.content}>
                            <Typography variant='h5' className={css.title}>
                                Pieniądze wracają do Ciebie
                            </Typography>
                            <Typography variant='p' className={css.info}>
                                Lokalni płacą podatki na miejscu, część z tych środków wraca do
                                Ciebie w postaci inwestycji w Twojej miejscowości.
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={clsx(css.apla, css.oneColumn, 'apla')}>
                        <Box className={css.icon}>
                            <img src={icon07} alt={css.icon}/>
                        </Box>
                        <Box className={css.content}>
                            <Typography variant='h5' className={css.title}>
                                Wspierasz lokalną społeczność
                            </Typography>
                            <Typography variant='p' className={css.info}>
                                Lokalne firmy inwestują w swoje miasto i region, zatrudniają lokalnych
                                pracowników oraz angażują się w lokalne inicjatywy. Lokalni internet blisko Ciebie.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
    )
}

export default BasicInfo;
